<template>
	<div class="rightButtons position-absolute">
		<!-- 초기화 -->
		<!-- <sf-button v-if="isButton_(scrId, 'IN')" line size="lg" icon="file" :onClick="initAction">
			{{ getMessage_('QWCC000067') }}
		</sf-button> -->

		<!-- 엑셀업로드 -->
		<sf-button v-if="isButton_(scrId, 'EU')" line icon="excel" :onClick="openModal"> {{ getMessage_('QWCC000927') }}</sf-button>

		<!-- 검사상세 템플릿 다운로드 -->
		<sf-button v-if="isButton_(scrId, 'EU')" line icon="file" :onClick="() => this.downExcelTemp('mst')">
			{{ getMessage_('QWCC001799') }}1
		</sf-button>
		<sf-button v-if="isButton_(scrId, 'EU')" line icon="file" :onClick="() => this.downExcelTemp('dtl')">
			{{ getMessage_('QWCC001799') }}2
		</sf-button>

		<!--엑셀 업로드 팝업창 영역 끝-->
		<excel-upload-modal :scrId="scrId" ref="excelUploadPop" @Refresh="Refresh" />
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import ExcelUploadModal from '@qms/Components/popup/ExcelUploadModal.vue'; //엑셀업로드 모달창

export default {
	props: {
		scrId: { type: String, default: '' },
		flgOsGrp: { type: Boolean, default: false },
		flgPqyapGrp: { type: Boolean, default: false },
		flgPqyrvGrp: { type: Boolean, default: false },
		flgPqyrgGrp: { type: Boolean, default: false }
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	components: {
		ExcelUploadModal
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		initAction() {
			try {
				// 컨펌창 실행
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('QWCC001395'), //초기화 하시겠습니까?
					buttons: [{ title: this.getMessage_('QWCC000067'), clickFn: () => this.initData() }] //초기화
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},
		initData() {
			const info = this.formInfo;
			this.onChangeParam_({ key: 'ckuClCd', value: '' }); //검사분류
			this.onChangeParam_({ key: 'ckuQty', value: '' }); //검사수량
			this.onChangeParam_({ key: 'badQty', value: '' }); //불량수량
			this.setGridRowInit_(); //그리드 영역 초기화
		},
		printAction() {},
		openModal() {
			try {
				// 컨펌창 실행
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('QWCC001808'), //업로드 하려는 항목을 선택해주세요.
					buttons: [
						{ title: this.getMessage_('QWCC001809'), clickFn: () => this.excelUpload('mst') }, //마스터 등록
						{ title: this.getMessage_('QWCC001810'), clickFn: () => this.excelUpload('dtl') }
					] //상세 등록
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},
		excelUpload(gbn) {
			let upVal = '';
			if (gbn === 'mst') {
				upVal = 'PART_CKU_MST'; //업무구분값(부품검사마스터)
			} else {
				upVal = 'PART_CKU_DTL'; //업무구분값(부품검사상세)
			}

			// 엑셀업로드팝업 호출
			const param = {
				title: this.getMessage_('QWCC001783'), //부품검사 엑셀엄로드 마스터
				apiGubun: upVal, //업무구분값(부품검사마스터)
				flag: 'I' //INSERT는 i Update U로 만듬
				//param1: '' //
			};
			this.$refs.excelUploadPop.open(param); //ExcelUploadModal 팝업에 정의한 open팝업을 실행한다.
		},
		Refresh() {
			// console.log('여기까지 오는가? >>>', partNo);
			const partNo = this.searchParams.partNo;
			this.$emit('Refresh', partNo);
		},
		downExcelTemp(gbn) {
			let params = {};

			if (gbn === 'mst') {
				params = { apiGubun: 'PART_CKU_MST' };
			} else {
				params = { apiGubun: 'PART_CKU_DTL' };
			}

			this.excelTempDown_(params)
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message || this.getMessage_('QWCC001920') //권한이 없거나 다운로드 할 수 없습니다.
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	}
};
</script>

<style lang="scss" scoped>
.rightButtons {
	top: 10px;
	right: 155px;
}
</style>
